/**
 * @generated SignedSource<<02cb086ae63bb674a95e78f53bc9736d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeOriginalAuthor"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includePostAuthor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "request"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "balance",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "StemPendingTransaction",
    "kind": "LinkedField",
    "name": "pending",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hash",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "author",
    "plural": false,
    "selections": (v4/*: any*/),
    "storageKey": null
  }
],
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "VibeStemLike",
    "kind": "LinkedField",
    "name": "stemLikeVibePost",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VibePost",
        "kind": "LinkedField",
        "name": "post",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stemLikesCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stemLikedByCurrentUser",
            "storageKey": null
          },
          {
            "condition": "includePostAuthor",
            "kind": "Condition",
            "passingValue": true,
            "selections": (v5/*: any*/)
          },
          {
            "condition": "includeOriginalAuthor",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "VibePost",
                "kind": "LinkedField",
                "name": "sharedPost",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "stemLikeButtonStemLikeVibePostMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "stemLikeButtonStemLikeVibePostMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "8b8b62fb77104056b62272411d8b91b2",
    "id": null,
    "metadata": {},
    "name": "stemLikeButtonStemLikeVibePostMutation",
    "operationKind": "mutation",
    "text": "mutation stemLikeButtonStemLikeVibePostMutation(\n  $request: StemLikeVibePostRequestInput!\n  $includePostAuthor: Boolean!\n  $includeOriginalAuthor: Boolean!\n) {\n  stemLikeVibePost(request: $request) {\n    id\n    user {\n      id\n      balance\n      pending {\n        hash\n        amount\n      }\n    }\n    post {\n      id\n      stemLikesCount\n      stemLikedByCurrentUser\n      author @include(if: $includePostAuthor) {\n        id\n        balance\n        pending {\n          hash\n          amount\n        }\n      }\n      sharedPost @include(if: $includeOriginalAuthor) {\n        author {\n          id\n          balance\n          pending {\n            hash\n            amount\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "b78940c7768c0449b8cb61151e5f4fb7";

module.exports = node;
